import React, {ReactNode} from "react";
import {Box, Text} from "@unibuddy/patron";

export function AuthFormError({children}: {children: ReactNode}) {
    return (
        <Box bgColor="red100" paddingX="xsmall" paddingY="small" borderRadius="xxsmall">
            <Text size="small" color="red800">
                {children}
            </Text>
        </Box>
    );
}
